module.exports = {
    SecertKey: '0133d209-d090-43c1-b896-aedda78b9f6c',
    RoutUser: '/user/home',
}


// WEBPACK FOOTER //
// ./src/config/index.js